import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../UserContext/UserContext";

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

/**
 * Route protection component for super admin-only pages
 * Redirects non-super admins to dashboard
 */
export const SuperAdminRoute = ({ children }: SuperAdminRouteProps) => {
  const { user } = useContext(UserContext);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== "super_admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
